import React, {useEffect, useState} from 'react';
import GenericDialog from "../../../components/dialog/generic-dialog.component";
import {translate} from "../../../translate/translate";
import {
    Box,
    Checkbox,
    FormControl,
    Grid,
    InputLabel,
    ListItemText,
    MenuItem,
    TextField,
    Typography
} from "@mui/material";
import Select from "@mui/material/Select";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {enUS, ptBR} from "date-fns/locale";
import {ImportAmortizationService} from "../../../services/import-integration-routines-service";
import {
    ExecuteRFCManual,
    ExecuteRFCManualConfig,
    mapExecuteRFCManualConfig,
} from "../../../models/basic/integration-routines";
import {toast} from "react-toastify";
import {ErrorComponent} from "../../../components/error/error.component";
import {Client} from "../../../models/basic/client";

function ExecuteManualRfcComponent(props: any) {

    const {
        openDialog,
        handleCloseDialog,
        isDisabled,
        rfc,
    } = props;

    const [config, setConfig] = useState<ExecuteRFCManualConfig>(new ExecuteRFCManualConfig());
    const [dataSourceClient, setDataSourceClient] = useState<Client[]>([]);
    const [dataSoucrcePlants, setDataSourcePlants] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (rfc && openDialog) {
            const c: ExecuteRFCManualConfig = mapExecuteRFCManualConfig[rfc.tipo as keyof typeof mapExecuteRFCManualConfig];
            setConfig(c);
            if (c.id_cliente) {
                loadClients();
            }
            if (c.plant) {
                loadPlants();
            }
        }
    }, [rfc]);

    const service = new ImportAmortizationService()

    const locale = translate.language == "pt" ? ptBR : enUS;

    const [object, setObject] = React.useState<ExecuteRFCManual>(new ExecuteRFCManual());
    const [startDate, setStartDate] = React.useState<Date | null>(null);
    const [endDate, setEndDate] = React.useState<Date | null>(null);
    const [date, setDate] = React.useState<Date | null>(null);

    const [dataSourcePOs, setDataSourcePOs] = React.useState<string[]>([
        'ZPB1',
        'ZPB2',
        'ZBSE',
    ]);
    const [selectedPOs, setSelectedPOs] = React.useState<string[]>([]);

    const renderPOs = (selected: any) => {
        return selectedPOs?.join(', ');
    }

    const allPOsSelected = () => {
        if (!dataSourcePOs) {
            return false;
        }
        return selectedPOs.length === dataSourcePOs.length;
    }

    const closeDialog = () => {
        handleCloseDialog();
        // limpar os estados
        setObject(new ExecuteRFCManual());
        setStartDate(null);
        setEndDate(null);
        setSelectedPOs([]);
    }

    const handleSubmit = () => {
        const payload = new ExecuteRFCManual();
        payload.begin_date = object.begin_date ? new Date(object.begin_date).toISOString().split("T")[0] : '';
        payload.end_date = object.end_date ? new Date(object.end_date).toISOString().split("T")[0] : '';
        payload.purchase_order_types = selectedPOs;
        payload.plant = object.plant;
        payload.sloc = object.sloc;
        payload.material_type = object.material_type;
        payload.material = object.material;
        payload.application_bom = object.application_bom;
        payload.sales_org = object.sales_org;
        payload.id_cliente = object.id_cliente;
        payload.client_nf = object.client_nf;
        payload.part_number = object.part_number;
        payload.date = object.date ? new Date(object.date).toISOString().split("T")[0] : '';

        payload.tipo = rfc.tipo;

        // excluir do payload os campos que não estão na configuração
        Object.keys(payload).forEach(key => {
            if (!(config as any)[key]) {
                delete (payload as any)[key];
            }
        });

        setLoading(true);
        service.executarRfcManual(payload)
            .then(response => {
                toast.success(translate.t("successfully_registered"));
                handleCloseDialog();
            })
            .catch((error: any) => {
                ErrorComponent(error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleObjChange = (newObj: any) => {
        setObject(newObj);
    }

    const handleStartDateChange = (event: any) => {
        const newObj = {
            ...object,
            begin_date: event,
        }
        setObject(newObj);
        setStartDate(event);
    };

    const handleDateChange = (event: any) => {
        const newObj = {
            ...object,
            date: event,
        }
        setObject(newObj);
        setDate(event);
    }

    const handleEndDateChange = (event: any) => {
        const newObj = {
            ...object,
            end_date: event,
        }
        setObject(newObj);
        setEndDate(event);
    };

    const invalidForm = () => {
    //     verificar se os campos que existem na configuração estão preenchidos
        if (config.begin_date && !startDate) {
            return true;
        }
        if (config.end_date && !endDate) {
            return true;
        }
        if (config.purchase_order_types && (!selectedPOs || selectedPOs.length === 0)) {
            return true;
        }
        if (config.id_cliente && !object.id_cliente) {
            return true;
        }
        if (config.client_nf && (!object.client_nf || object.client_nf.trim() === '')) {
            return true;
        }
        if (config.part_number && (!object.part_number || object.part_number.trim() === '')) {
            return true;
        }
        if (config.date && !object.date) {
            return true;
        }
        return false;
    }

    const loadClients = () => {
        service.getClients()
            .then(response => {
                setDataSourceClient(response.data);
            })
            .catch((error: any) => {
                ErrorComponent(error);
            });
    }

    const loadPlants = () => {
        service.getPlants()
            .then(response => {
                setDataSourcePlants(response.data);
            })
            .catch((error: any) => {
                ErrorComponent(error);
            });
    }


    return (
        <GenericDialog
            open={openDialog}
            onClose={() => {
                closeDialog();
            }}
            title={"Rodar manual"}
            labelButton={"Executar"}
            disableConfirm={invalidForm()}
            handleConfirm={() => {
                handleSubmit();
            }}
            loading={loading}
            disableClose={true}
            closeButtonText="close"
            colorButton={"primary"}>

            <Box display="flex" flexDirection="row" marginBottom="10px">
                <Typography variant="body1" fontWeight="bold" marginRight="5px">RFC:</Typography>
                <Typography variant="body1">{rfc?.rfc ?? '-'}</Typography>
            </Box>

            <Grid container spacing={2} direction={"row"}>
                {config.plant && (
                    <Grid size={12}>
                        <FormControl fullWidth>
                            <InputLabel required={true}>
                                Planta
                            </InputLabel>
                            <Select
                                name="plant"
                                label={"Planta"}
                                variant={"outlined"}
                                fullWidth
                                autoFocus={false}
                                value={object.plant}
                                onChange={(event: any) => {
                                    const plant = event.target.value;
                                    handleObjChange({
                                        ...object,
                                        plant: plant,
                                    });
                                }}
                                disabled={loading}
                            >
                                {dataSoucrcePlants?.map((plant: any) => (
                                    <MenuItem key={plant.plant} value={plant.plant}>
                                        <ListItemText primary={plant.plant}/>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                )}

                {config.sloc && (
                    <Grid size={12}>
                        <TextField
                            name="sloc"
                            label={"Sloc"}
                            variant="outlined"
                            fullWidth
                            required
                            value={object.sloc}
                            type="text"
                            disabled
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                let value = event.target.value;
                                if (value.length > 255) {
                                    return;
                                }
                                handleObjChange({
                                    ...object,
                                    sloc: value,
                                });
                            }}
                        />
                    </Grid>
                )}

                {config.material_type && (
                    <Grid size={12}>
                        <TextField
                            name="material_type"
                            label={"Material Type"}
                            variant="outlined"
                            fullWidth
                            required
                            value={object.material_type}
                            type="text"
                            disabled
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                let value = event.target.value;
                                if (value.length > 255) {
                                    return;
                                }
                                handleObjChange({
                                    ...object,
                                    material_type: value,
                                });
                            }}
                        />
                    </Grid>
                )}

                {config.material && (
                    <Grid size={12}>
                        <TextField
                            name="material"
                            label={"Material"}
                            variant="outlined"
                            fullWidth
                            required
                            value={object.material}
                            type="text"
                            disabled
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                let value = event.target.value;
                                if (value.length > 255) {
                                    return;
                                }
                                handleObjChange({
                                    ...object,
                                    material: value,
                                });
                            }}
                        />
                    </Grid>
                )}

                {config.application_bom && (
                    <Grid size={12}>
                        <TextField
                            name="application_bom"
                            label={"Application BOM"}
                            variant="outlined"
                            fullWidth
                            required
                            value={object.application_bom}
                            type="text"
                            disabled
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                let value = event.target.value;
                                if (value.length > 255) {
                                    return;
                                }
                                handleObjChange({
                                    ...object,
                                    application_bom: value,
                                });
                            }}
                        />
                    </Grid>
                )}

                {config.sales_org && (
                    <Grid size={12}>
                        <TextField
                            name="sales_org"
                            label={"Sales Org"}
                            variant="outlined"
                            fullWidth
                            required
                            value={object.sales_org}
                            type="text"
                            disabled
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                let value = event.target.value;
                                if (value.length > 255) {
                                    return;
                                }
                                handleObjChange({
                                    ...object,
                                    sales_org: value,
                                });
                            }}
                        />
                    </Grid>
                )}

                {config.begin_date && (
                    <Grid size={6}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
                            <DatePicker
                                label={translate.t("initial_date") + ' *'}
                                value={startDate}
                                onChange={handleStartDateChange}
                                inputRef={(props: any) => (
                                    <TextField
                                        {...props}
                                        required={false}
                                    />
                                )}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        required: false,
                                    }
                                }}
                                disabled={loading}
                            />
                        </LocalizationProvider>
                    </Grid>
                )}

                {config.end_date && (
                    <Grid size={6}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
                            <DatePicker
                                label={translate.t("final_date") + ' *'}
                                value={endDate}
                                onChange={handleEndDateChange}
                                inputRef={(props: any) => (
                                    <TextField
                                        {...props}
                                        required={false}
                                    />
                                )}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        required: false,
                                    }
                                }}
                                minDate={new Date(startDate + "T12:00:00") || null}
                                disabled={loading}
                            />
                        </LocalizationProvider>
                    </Grid>
                )}

                {config.date && (
                    <Grid size={12}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
                            <DatePicker
                                label={translate.t("date") + ' *'}
                                value={date}
                                onChange={handleDateChange}
                                inputRef={(props: any) => (
                                    <TextField
                                        {...props}
                                        required={false}
                                    />
                                )}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        required: false,
                                    }
                                }}
                                disabled={loading}
                            />
                        </LocalizationProvider>
                    </Grid>
                )}

                {config.purchase_order_types && (
                    <Grid size={12}>
                        <FormControl fullWidth>
                            <InputLabel required={true}>Tipos de POs</InputLabel>
                            <Select
                                name="pos_type"
                                label="Tipos de POs"
                                variant={"outlined"}
                                fullWidth
                                autoFocus={false}
                                value={selectedPOs}
                                onChange={(event: any) => {
                                    if (event.target.value.includes(0)) {
                                        if (!allPOsSelected()) {
                                            const pos_type = dataSourcePOs?.map((pos_type: any) => pos_type);
                                            setSelectedPOs(pos_type || []);
                                            handleObjChange({
                                                ...object,
                                                pos_type: pos_type || [],
                                            })
                                            return;
                                        }
                                        setSelectedPOs([]);
                                        handleObjChange({
                                            ...object,
                                            pos_type: [],
                                        })
                                        return;
                                    }
                                    setSelectedPOs(event.target.value);
                                    handleObjChange({
                                        ...object,
                                        pos_type: event.target.value,
                                    })
                                }}
                                multiple
                                renderValue={(selected) => renderPOs(selected)}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: '400px',
                                        },
                                    },
                                    disableAutoFocusItem: true,
                                }}
                                inputProps={{
                                    sx: {
                                        maxWidth: '480px !important',
                                        width: '480px !important',
                                    }
                                }}
                                disabled={loading}
                            >
                                <MenuItem key={0} value={0}>
                                    <Checkbox checked={allPOsSelected()}/>
                                    <ListItemText primary={
                                        <Box display="flex" alignItems="center" justifyContent="space-between">
                                            <Typography variant="body1">{translate.t('all')}</Typography>
                                            {allPOsSelected() && <Typography variant="body2"
                                                                                     color="gray">{translate.t('clear')}</Typography>}
                                        </Box>
                                    }/>
                                </MenuItem>
                                {dataSourcePOs?.map((pos: any) => (
                                    <MenuItem key={pos} value={pos}>
                                        <Checkbox checked={selectedPOs.includes(pos)}/>
                                        <ListItemText primary={pos}/>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                )}

                {config.id_cliente && (
                    <Grid size={12}>
                        <FormControl fullWidth>
                            <InputLabel required={true}>
                                {translate.t("client")}
                            </InputLabel>
                            <Select
                                name="client"
                                label={translate.t("client")}
                                variant={"outlined"}
                                fullWidth
                                autoFocus={false}
                                value={object.id_cliente}
                                onChange={(event: any) => {
                                    const id_cliente = event.target.value;
                                    handleObjChange({
                                        ...object,
                                        id_cliente: id_cliente,
                                    });
                                }}
                                disabled={loading}
                            >
                                {dataSourceClient?.map((client: Client) => (
                                    <MenuItem key={client.id} value={client.id}>
                                        <ListItemText primary={client.name}/>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                )}

                {config.client_nf && (
                    <Grid size={6}>
                        <TextField
                            name="client_nf"
                            label={"Client NF"}
                            variant="outlined"
                            fullWidth
                            required
                            value={object.client_nf}
                            type="text"
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                let value = event.target.value;
                                if (value.length > 255) {
                                    return;
                                }
                                handleObjChange({
                                    ...object,
                                    client_nf: value,
                                });
                            }}
                            disabled={loading}
                        />
                    </Grid>
                )}

                {config.part_number && (
                    <Grid size={6}>
                        <TextField
                            name="part_number"
                            label={"Part Number"}
                            variant="outlined"
                            fullWidth
                            required
                            value={object.part_number}
                            type="text"
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                let value = event.target.value;
                                if (value.length > 255) {
                                    return;
                                }
                                handleObjChange({
                                    ...object,
                                    part_number: value,
                                });
                            }}
                            disabled={loading}
                        />
                    </Grid>
                )}
            </Grid>
        </GenericDialog>
    );
}

export default ExecuteManualRfcComponent;
